import React from 'react';
import PropTypes from 'prop-types';
import { useQuery } from '@apollo/client';
import { Container, Row, Column } from '@pella/sash-framework';
import { CTA } from '../../';
import { contentstackClient } from '../../../utils/contentstack-client';
import { GET_ARTICLES_BY_TAXONOMY } from '../../../enums/contentstack-graphql';
import { isValidArray } from '../../utilities/validations';

import CardRenderer from '../card-types/card-renderer';

const DynamicArticle = ({ data, dynamic, count = 1, className, parent, ...other }) => {
	const filters = isValidArray(dynamic?.filter_tags) ? dynamic?.filter_tags?.map((filter) => ({ taxonomies: { filter_by: { term_in: filter?.split(', ') } } })) : [];
	const { data: articles } = useQuery(GET_ARTICLES_BY_TAXONOMY, { client: contentstackClient, variables: { filters, limit: count }, skip: !isValidArray(dynamic?.filter_tags) });

	const setBackgroundColor = (color) => {
		switch (color) {
			case 'black':
				return 'bg-black';
			case 'white':
				return 'bg-white';
			case 'yellow':
				return 'bg-primary';
			case 'dark gray':
				return 'bg-gray-80';
			case 'light gray':
				return 'bg-gray-3';
			default:
				return '';
		}
	};

	if (!isValidArray(articles?.all_articles?.items)) return null;

	return (
		<div
			className={`dynamicArticle py-8 md:py-10 xl:py-12 ${setBackgroundColor(data?.background_color)} ${className || ''}`}
			data-testid='dynamic-article'
			{...other}
		>
			<Container>
				{data?.heading && <h2 className='mb-7'>{data.heading}</h2>}

				<Row
					justify={articles.all_articles.items.length > 1 ? 'center' : ''}
					verticalGutters={true}
				>
					{articles.all_articles.items.map((article, index) => (
						<Column
							xs={12}
							lg={6}
							key={index}
						>
							<CardRenderer
								data={{
									card_type: 'standard',
									image: [{ image: article.seo?.thumbnailConnection?.edges?.[0]?.node }],
									ctas: [{ link: { href: article.url }, aria: article.top_content?.heading }],
									heading: article.top_content?.heading,
									seo_tag: article.top_content?.heading,
								}}
								className='[&_img]:h-40 md:[&_img]:h-48 xl:[&_img]:h-80'
							/>
						</Column>
					))}
				</Row>

				{isValidArray(dynamic?.ctas) && (
					<div className={`mt-7 ${articles?.length > 1 ? 'text-center' : ''}`}>
						<CTA data={dynamic.ctas[0]} />
					</div>
				)}
			</Container>
		</div>
	);
};

DynamicArticle.propTypes = {
	data: PropTypes.object,
	dynamic: PropTypes.object,
	count: PropTypes.number,
	className: PropTypes.string,
	parent: PropTypes.string,
};

export default DynamicArticle;
